import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "remixicon/fonts/remixicon.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, persistor } from "./store/store"; // ✅ Import persistor from store
import * as Sentry from "@sentry/react";
import { PersistGate } from "redux-persist/integration/react";
// ❌ REMOVED: import { persistStore } from "redux-persist";
import { BrowserRouter as Router } from "react-router-dom";
import { Logger } from './utils/logger';

// 🛡️ Suppress benign ResizeObserver errors from React Flow and other UI libraries
// This error occurs when resize notifications can't be delivered in a single frame (expected behavior)
const suppressResizeObserverError = (event: ErrorEvent | Event) => {
  const error = (event as ErrorEvent).error || (event as ErrorEvent).message;
  const message = typeof error === 'string' ? error : error?.message || '';

  if (
    message.includes('ResizeObserver loop') ||
    message === 'ResizeObserver loop completed with undelivered notifications.' ||
    message === 'ResizeObserver loop limit exceeded'
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
  return false;
};

// Catch early before React error boundaries
window.addEventListener('error', suppressResizeObserverError, true); // Use capture phase!

// Also override console.error to suppress these messages
const originalConsoleError = console.error;
console.error = function(...args) {
  const message = args[0]?.toString() || '';
  if (message.includes('ResizeObserver loop')) {
    return; // Suppress
  }
  originalConsoleError.apply(console, args);
};

Sentry.init({
  dsn: "https://0b18e9e9f9cc45d3879f03b965c5ca20@o4504090766934016.ingest.sentry.io/4504090793738240",
  integrations: [new Sentry.BrowserTracing()],
  tracesSampleRate: 0.05,
  beforeSend(event) {
    // Don't send ResizeObserver errors to Sentry
    const message = event.message || '';
    if (
      message.includes('ResizeObserver loop') ||
      message === 'ResizeObserver loop completed with undelivered notifications.' ||
      message === 'ResizeObserver loop limit exceeded'
    ) {
      return null;
    }
    return event;
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// ❌ REMOVED: let persistor = persistStore(store);
// ✅ Now using persistor imported from store.tsx

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <Router>
        <App />
      </Router>
    </PersistGate>
  </Provider>
);

reportWebVitals();